var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "field is-centered submit-button" }, [
    _c("div", { staticClass: "control" }, [
      _c(
        "button",
        {
          staticClass: "button is-uppercase is-primary",
          class: { "is-loading": _vm.loading },
          attrs: { type: "submit", disabled: _vm.disabled }
        },
        [_vm._v("\n      " + _vm._s(_vm.text) + "\n    ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }